const gradients = {
        green: { from: '#10b981', to: '#166534', deg: 90 },
        greenTeal: { from: '#10b981', to: '#14b8a6', deg: 90 },
        emerald: { from: '#10b981', to: '#059669', deg: 135 },
        lightblue: { from: '#3b82f6', to: '#06b6d4', deg: 90 },
        blue: { from: '#3b82f6', to: '#8b5cf6', deg: 135 },
        darkerBlue: { from: '#4f46e5', to: '#7c3aed', deg: 90 },
        orange : { from: '#f97316', to: '#ef4444', deg: 120 }
    };

export default gradients;